import { render } from "./EditLimitsForComponent.vue?vue&type=template&id=7521c6eb"
import script from "./EditLimitsForComponent.vue?vue&type=script&lang=js"
export * from "./EditLimitsForComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__